import { useContext } from "react";

import AnswersContext from "../contexts/AnswersContext";

const ResetAnswersButton = ({ category, topic, className }) => {
  const { resetAnswers } = useContext(AnswersContext);
  const effectiveText = topic ? topic : category;

  return (
    <div className="d-grid gap-2">
      <button
        type="reset"
        className={className}
        onClick={(e) => {
          e.preventDefault();
          resetAnswers(category, topic);
        }}
      >
        Reset {effectiveText} Answers
      </button>
    </div>
  );
};

export default ResetAnswersButton;
